import DetailPeek from './DetailPeek'

export default DetailPeek
